<ng-container class="report-custom-container"
  ><app-report-select
    [title]="'Reporte cajas por paciente'"
    (previewClicked)="handlePreviewClick()"
    (printClicked)="handlePrintClick()"
    (pdfClicked)="handlePdfClick()"
    (excelClicked)="handleExcelClick()"
    [disabled]="!form.controls['selectedInstitution'].valid"
  >
  <div slot="content" class="container-options">
      <form [formGroup]="form">
       

        <section class="filter-container institutions" >
          <div class="subtitle">Centro</div>
          <app-form-field
            class="field"
            [type]="'select'"
            label="Selecciona un centro"
            [fieldControl]="form.controls['selectedInstitution'] | asFormControl"
            [options]="selectOptionsInsitutions">
          </app-form-field>
  
        </section>

  
          <section class="filter-container interval">
            <div class="subtitle">Intervalo</div>

              <mat-form-field
              appDateFormat
              class="col-12"
              >
                <input
                  matInput
                  [matDatepicker]="specificDay"
                  formControlName="specificDay"
                />
                <mat-datepicker-toggle
                  matSuffix                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
                  [for]="specificDay"
                ></mat-datepicker-toggle>
                <mat-datepicker 
                #specificDay
                  startView="year"
                  (monthSelected)="chosenMonthHandler($event, specificDay)">
                </mat-datepicker>
              </mat-form-field>
          </section>

        <section class="filter-container">
          <div class="subtitle">Filtrar por</div>
          <mat-checkbox 
            class="col-2"
            [disabled]="!form.controls['selectedInstitution'].valid"
            (change)="toggleSelectPatient()" 
          >
            Paciente
          </mat-checkbox>
          <mat-form-field *ngIf="showPatientSelect" class="col-5">
            <mat-select formControlName="selectedPatient">
              <mat-option
                *ngFor="let option of selectOptionsPatients"
                [value]="option.id"
              >
                {{ option.num }} - {{ option.nam }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </section>
      </form>
    </div>
  </app-report-select>
</ng-container>
